const Winnonie = {
  EN: {
    title: 'Winnonie',
    menus: {
      logEvLocker: 'Ev Locker Log',
      locker: 'Ev Locker',
      transaction: 'Transaction Log',
      service_point: 'Service Points',
      user: 'Users',
      battery: 'Battery',
      setting: 'Setting',
      logStation: 'Station Log',
    },
    service: {
      station: {
        title: 'Station',
        placeHolder: 'Station Search',
      },
      stationLog: {
        title: 'Station',
        placeHolder: 'Station Search',
      },
      status: {
        title: 'Statuses',
        status: 'Status',
        actionStatus: 'Action Status',
        reason: 'Reason',
        action: 'Actions',
        all: 'All',
        active: 'Active',
        inactive: 'Inactive',
        warning: 'Warning',
        deleted: 'Deleted',
        reservation: 'Reservation Time Out (Mins)',
        chargeCycleLimit: 'Charge Cycle Limit',
        fullChargeThreshold: 'Full Charged Threshold (%)',
        reChargeThreshold: 'Recharge Threshold (%)',
        tempAlert: 'Temp Alert (C)',
        temperature: 'Temperature',
        level: 'Level',
        flood: 'Flood',
        gases: 'Gases',
      },
      agent: {
        title: 'Agent / Partner',
        placeHolder: 'Agent / Partner Search',
      },
      numberStation: {
        title: 'Station No.',
        placeHolder: 'Station Number Search',
      },
      province: {
        title: 'Provinces',
        placeHolder: 'Select Provinces',
      },
      table: {
        jobId: 'Job Id',
        actionAt: 'Action At',
        manageTable: 'Manage Table',
        delete: 'Delete',
        active: 'Active',
        contact: 'Contact',
        number: 'No.',
        firstName: 'Firstname',
        lastName: 'Lastname',
        numberWNN: 'Station No.',
        station: 'Station',
        address: 'Address',
        type: 'Type',
        location: 'Location',
        phone: 'Phone',
        email: 'Email',
        fax: 'Fax',
        line: 'Line',
        latitude: 'Latitude',
        longitude: 'Longitude',
        district: 'District',
        province: 'Province',
        status: 'Status',
        available: 'Available',
        active_inactive: 'Activation',
        power: 'Breaker',
        setting: 'Setting',
        floods: 'Floods',
        gases: 'Gases',
        temp: 'Temp (C)',
        power_meter: 'Meter (Kwh)',
        locker: {
          title: 'Locker',
          total: 'Total',
          empty: 'Empty',
          charging: 'Charging',
          full: 'Charged',
          reserve: 'Reserved',
          closed: 'Closed',
          failed: 'Failed',
          inactive: 'Inactive',
        },
        inactive: 'Inactive',
        niuCharger: {
          title: 'Niu Charger',
        },
        universalCharger: {
          title: 'Universal Charger',
        },
        checkAll: 'Select All',
      },
      modal: {
        delete: 'Do You Want To Delete?',
        active: 'Do You Want To Active?',
        inactive: 'Do You Want To Inactive?',
        powerInactive: 'Do You Want To Power Inactive?',
        powerActive: 'Do You Want To Power Active?',
        reason: 'Reason',
      },
    },
    user: {
      table: {
        licensePlate: 'License Plate',
        idCard: 'Id Card Number',
        name: 'Full Name',
        driverCard: 'Driver Card Number',
        phone: 'Phone',
        status: 'Statuses',
        autoSync: 'Auto Sync Data',
        syncNow: 'Sync Now',
        download: 'Download All Data',
        others: 'Others',
        usage: 'Usage',
      },
      modal: {
        syncNow: 'Do You Want To Sync Now?',
        download: 'Do You Want To Download?',
      },
      status: {
        all: 'All',
        active: 'Active',
        inactive: 'Inactive',
        deleted: 'Deleted',
        suspended: 'Suspended',
        pending: 'Pending',
      },
    },
    battery: {
      table: {
        serial: 'S/N Battery',
        timeToFull: 'Remain(H)',
        chargingCurrent: 'Current(A)',
        chargingVoltage: 'Voltage(V)',
        cycleCount: 'Cycle',
        temperature: 'Temp(C)',
        stations: 'Stations',
        station: 'Station',
        name: 'Full Name',
        lockerNumber: 'Locker',
        carId: 'Car Id',
        usage: 'Usage',
        borrow: 'Borrow Date',
        return: 'Return Date',
        action: 'Action Date',
        process: 'Process',
        stateOfCharge: 'Soc(%)',
        status: 'Batt. Status',
        statuses: 'Battery Statuses',
        autoSync: 'Auto Sync Data',
        syncNow: 'Sync Now',
        download: 'Download All Data',
        others: 'Others',
        batteryUsage: 'Battery Usage',
        type: 'Type',
      },
      process: {
        insert: 'Return Battery',
        takeOut: 'Borrow Battery',
        neverUse: 'Never Use',
      },
      status: {
        noLoad: 'Full',
        discharge: 'Discharge',
        charge: 'Charging',
        overCharge: 'Over Charge',
        overDischarge: 'Over Discharge',
        overCurrentCharge: 'Over Current Charge',
        overCurrentDischarge: 'Over Current Discharge',
        overheat: 'Overheat',
        superCool: 'Low Temp',
        other: 'Other Errors',
        short: 'Short Circuit',
        water: 'Water Leak',
        mosDamage: 'Bms Damage',
        unknown: 'Unknown',
        normalCharge: 'Normal Charge',
        slowRecovery: 'Slow Recovery',
        noPower: 'No Power',
        idle: 'Idle',
        full: 'Full',
        fastRecovery: 'Fastrecovery',
        error: 'Error',
        softFull: 'Soft Full',
        warning: 'Warning',
      },
      modal: {
        syncNow: 'Do You Want To Sync Now?',
        download: 'Do You Want To Download?',
        addBattery: 'Add Battery',
      },
      search: {
        time: 'Service Time',
        all: 'All',
        period: 'Period',
      },
      error: {
        serial: 'Please Enter Serial Number',
        type: 'Please Enter Battery Type',
      },
    },
    locker: {
      table: {
        number: 'Locker No.',
        serial: 'S/N Battery',
        cycle: 'Cycle',
        voltage: 'Voltage(V)',
        current: 'Current(A)',
        capacity: 'Capacity(%)',
        stateOfCharge: 'Soc(%)',
        lockerStatus: 'Locker Statuses',
        batteryStatus: 'Batt. Status',
        fullCharge: 'Remain(H)',
        charger: 'Charger Status',
        temperature: 'Temp(C)',
        activeInactive: 'Active / Inactive',
        inactiveReason: 'Inactive Reason',
        update: 'Update Status',
        restart: 'Restart Station',
        open: 'Open',
        active: 'Active',
        inactive: 'Inactive',
        stations: 'Stations',
        action: 'Action',
        actions: 'Actions',
        actionAt: 'Action At',
        actionStatus: 'Action Status',
        status: 'Statuses',
        lockerType: 'Type',
        locker: 'Locker',
        reason: 'Reason',
        stationName: 'Station',
      },
      modal: {
        updateLocker: 'Do You Want To Update Locker?',
        update: 'Do You Want To Update ?',
        openLocker: 'Do You Want To Open Locker?',
        active: 'Do You Want To Active?',
        inactive: 'Do You Want To Inactive?',
        restart: 'Do You Want To Restart?',
      },
      status: {
        all: 'All',
        empty: 'Empty',
        failed: 'Failed',
        inactive: 'Inactive',
        charging: 'Charging',
        charged: 'Full',
        reserved: 'Reserved',
        pending: 'Pending',
      },
    },
    transaction: {
      table: {
        action: 'Action',
        actionStatus: 'Action Status',
        actionAt: 'Action Date',
        dailyReport: 'Download Daily Report',
        allReport: 'Download Report',
        noMovementReport: 'Download No Movement Report',
        reason: 'Reason',
      },
      modal: {
        noMovement: 'Number Of Days To Download',
        all: 'Period To Download',
      },
      action: {
        activate: 'Activate',
        inactivate: 'Inactivate',
        maintain: 'Maintain',
        cancel: 'Cancel',
        open: 'Open',
        insert: 'Insert',
        takeout: 'Take Out',
        reserve: 'Reserve',
      },
      actionStatus: {
        success: 'Success',
        failed: 'Failed',
      },
      error: {
        noMovementRequire: 'Please Enter Number Of Days',
        noMovementMin: 'Number Of Days Must More Than 0',
        noMovementInteger: 'Please Enter Integer Number',
      },
    },
    logUser: {
      table: {
        usageData: 'Usage Data',
      },
    },
    logBattery: {
      table: {
        batteryTransaction: 'Battery Transaction',
        lockerNumber: 'Locker No.',
      },
    },
    setting: {
      error: {
        integer: 'This Field Is Required Number Only.',
        require: 'This Field Is Required',
        positive: 'This Field Must Be Positive Number',
      },
    },
  },

  TH: {
    title: 'Winnonie',
    menus: {
      locker: 'ตู้ชาร์จ',
      logEvLocker: 'บันทึกการใช้ตู้ชาร์จ',
      transaction: 'บันทึกธุรกรรม',
      service_point: 'จุดบริการ',
      user: 'ผู้ใช้',
      battery: 'แบตเตอรี่',
      setting: 'การตั้งค่า',
      logStation: 'บันทึกสถานี',
    },
    service: {
      station: {
        title: 'สถานี',
        placeHolder: 'ค้นหาสถานี',
      },
      status: {
        jobId: 'Job ID',
        actionAt: 'Action at',
        title: 'สถานะ',
        all: 'ทั้งหมด',
        active: 'ใช้งาน',
        inactive: 'ไม่ใช้งาน',
        warning: 'เตือน',
        deleted: 'ที่ถูกลบ',
        reservation: 'เวลาหมดอายุการจอง (นาที)',
        chargeCycleLimit: 'จำกัดวงจรการชาร์จ',
        fullChargeThreshold: 'เกณฑ์การชาร์จเต็ม (%)',
        reChargeThreshold: 'เกณฑ์การชาร์จใหม่ (%)',
        tempAlert: 'อุณหภูมิขั้นต่ำในการแจ้งเตือน (C)',
        temperature: 'อุณหภูมิ',
        level: 'ระดับ',
        flood: 'น้ำท่วม',
        gases: 'ก๊าซ',
      },
      agent: {
        title: 'ตัวแทน / คู่ค้า',
        placeHolder: 'ค้นหาตัวแทน / คู่ค้า',
      },
      numberStation: {
        title: 'หมายเลขสถานี',
        placeHolder: 'ค้นหาหมายเลขสถานี',
      },
      province: {
        title: 'จังหวัด',
        placeHolder: 'เลือกจังหวัด',
      },
      table: {
        manageTable: 'จัดการตาราง',
        delete: 'ลบ',
        inactive: 'ไม่ใช้งาน',
        active: 'ใช้งาน',
        contact: 'ติดต่อ',
        number: 'ลำดับที่',
        firstName: 'ชื่อ',
        lastName: 'นามสกุล',
        numberWNN: 'หมายเลขสถานี',
        station: 'สถานี',
        address: 'ที่อยู่',
        type: 'ประเภท',
        location: 'สถานที่',
        phone: 'โทรศัพท์',
        email: 'อีเมล',
        fax: 'แฟกซ์',
        line: 'ไลน์',
        latitude: 'ละติจูด',
        longitude: 'ลองจิจูด',
        district: 'อำเภอ',
        province: 'จังหวัด',
        status: 'สถานะ',
        total: 'ทั้งหมด',
        available: 'พร้อมใช้งาน',
        empty: 'ว่าง',
        charging: 'กำลังชาร์จ',
        full: ' ชาร์จเต็ม',
        reserve: 'จอง',
        closed: 'ปิด',
        failed: 'ผิดพลาด',
        active_inactive: 'การเปิดใช้งาน',
        power: 'เบรกเกอร์',
        setting: 'การตั้งค่า',
        floods: 'น้ำท่วม',
        gases: 'ก๊าซ',
        temp: 'อุณหภูมิ (C)',
        power_meter: 'มิเตอร์ (kWh)',
        locker: {
          title: 'ล็อกเกอร์',
          total: 'ทั้งหมด',
          empty: 'ว่าง',
          charging: 'กำลังชาร์จ',
          full: ' ชาร์จเต็ม',
          reserve: 'Reserved',
          closed: 'จอง',
          failed: 'ผิดพลาด',
          inactive: 'ปิด',
        },
        niuCharger: {
          title: 'เครื่องชาร์จ NIU',
        },
        universalCharger: {
          title: 'เครื่องชาร์จ Universal',
        },
      },
      modal: {
        delete: 'คุณต้องการลบหรือไม่?',
        active: 'คุณต้องการเปิดใช้งานหรือไม่?',
        inactive: 'คุณต้องการยกเลิกการใช้งานหรือไม่?',
        powerInactive: 'คุณต้องการปิดไฟหรือไม่?',
        powerActive: 'คุณต้องการเปิดไฟหรือไม่?',
        reason: 'เหตุผล ',
      },
    },
    user: {
      table: {
        licensePlate: 'ป้ายทะเบียน',
        idCard: 'หมายเลขบัตรประชาชน',
        name: 'ชื่อเต็ม',
        driverCard: 'หมายเลขบัตรขับขี่',
        phone: 'โทรศัพท์',
        status: 'สถานะ',
        autoSync: 'ซิงค์ข้อมูลอัตโนมัติ',
        syncNow: 'ซิงค์ตอนนี้',
        download: 'ดาวน์โหลดข้อมูลทั้งหมด',
        others: 'อื่นๆ',
        usage: 'การใช้งาน',
      },
      modal: {
        syncNow: 'คุณต้องการซิงค์ข้อมูลตอนนี้หรือไม่?',
        download: 'คุณต้องการดาวน์โหลดข้อมูลหรือไม่?',
      },
      status: {
        all: 'ทั้งหมด',
        active: 'ใช้งาน',
        inactive: 'ไม่ใช้งาน',
        deleted: 'ที่ถูกลบ',
        suspended: 'ถูกระงับ',
        pending: 'รอดำเนินการ',
      },
    },
    battery: {
      table: {
        serial: 'S/N แบตเตอรี่',
        chargingCurrent: 'กระแส(A)',
        chargingVoltage: 'แรงดัน(V)',
        timeToFull: 'ชั่วโมงที่แบตจะเต็ม',
        lockerNumber: 'ล็อคเกอร์',
        temperature: 'อุณหภูมิ (C)',
        station: 'สถานี',
        stations: 'สถานี',
        name: 'ชื่อเต็ม',
        carId: 'ID รถ',
        usage: 'การใช้งาน',
        borrow: 'วันที่ยืม',
        return: 'วันที่คืน',
        action: 'วันที่ดำเนินการ',
        process: 'กระบวนการ',
        status: 'สถานะแบตเตอรี่',
        autoSync: 'ซิงค์ข้อมูลอัตโนมัติ',
        syncNow: 'ซิงค์ตอนนี้',
        download: 'ดาวน์โหลดข้อมูลทั้งหมด',
        others: 'อื่นๆ',
        batteryUsage: 'การใช้งานแบตเตอรี่',
        type: 'ประเภท',
      },
      process: {
        insert: 'คืนแบตเตอรี่',
        takeOut: 'ยืมแบตเตอรี่',
        neverUse: 'ไม่เคยใช้',
      },
      status: {
        noLoad: 'เต็ม',
        discharge: 'ถ่ายไฟฟ้า',
        charge: 'กำลังชาร์จ',
        overCharge: 'ชาร์จเกิน',
        overDischarge: 'ถ่ายไฟฟ้าเกิน',
        overCurrentCharge: 'ชาร์จกระแสเกิน',
        overCurrentDischarge: 'ถ่ายกระแสเกิน',
        overheat: 'ชาร์จเกิน',
        superCool: 'ต่ำกว่าอุณหภูมิปกติ',
        other: 'ข้อผิดพลาดอื่นๆ',
        short: 'วงจรสั้น',
        water: 'รั่วน้ำ',
        mosDamage: 'การทำลาย BMS',
        unknown: 'ไม่ทราบ',
        normalCharge: 'ชาร์จปกติ',
        slowRecovery: 'การกู้คืนช้า',
        noPower: 'ไม่มีพลังงาน',
        idle: 'ว่าง',
        full: 'เต็ม',
        fastRecovery: 'กู้คืนอย่างรวดเร็ว',
        error: 'ข้อผิดพลาด',
        softFull: 'เต็มอ่อน',
        warning: 'คำเตือน',
      },
      modal: {
        syncNow: 'คุณต้องการซิงค์ข้อมูลตอนนี้หรือไม่?',
        download: 'คุณต้องการดาวน์โหลดข้อมูลหรือไม่?',
        addBattery: 'เพิ่มแบตเตอรี่',
      },
      search: {
        time: 'เวลาบริการ',
        all: 'ทั้งหมด',
        period: 'ระยะเวลา',
      },
      error: {
        serial: 'โปรดใส่หมายเลขซีเรียล',
        type: 'กรุณาใส่ประเภทของแบตเตอรี่',
      },
    },
    locker: {
      table: {
        number: 'หมายเลขล็อคเกอร์',
        serial: 'S/N แบตเตอรี่',
        cycle: 'จำนวนวงจร',
        voltage: 'แรงดัน(V)',
        current: 'กระแส(A)',
        capacity: 'ความจุ(%)',
        stateOfCharge: 'Soc(%)',
        lockerStatus: 'สถานะล็อคเกอร์',
        locker: 'ล็อคเกอร์',
        batteryStatus: 'สถานะแบตเตอรี่',
        lastUpdate: 'อัพเดตล่าสุด',
        operation: 'การดำเนินการ',
        available: 'พร้อมใช้งาน',
        using: 'กำลังใช้งาน',
        station: 'สถานี',
        inactiveReason: 'เหตุผลในการปิดใช้งาน',
        stationName: 'สถานี',
      },
      status: {
        available: 'พร้อมใช้งาน',
        using: 'กำลังใช้งาน',
        error: 'ข้อผิดพลาด',
        warning: 'คำเตือน',
        charging: 'กำลังชาร์จ',
      },
      modal: {
        lockerStatus: 'สถานะล็อคเกอร์',
        batteryStatus: 'สถานะแบตเตอรี่',
        lastUpdate: 'อัพเดตล่าสุด',
        lockerDetail: 'รายละเอียดล็อคเกอร์',
      },
    },
    setting: {
      dropdown: {
        language: 'ภาษา',
        theme: 'ธีม',
      },
      language: {
        english: 'อังกฤษ',
        thai: 'ไทย',
      },
      theme: {
        light: 'แสงสว่าง',
        dark: 'แสงสลัว',
      },
      error: {
        integer: 'โปรดใส่เฉพาะตัวเลข',
        require: 'กรุณากรอกข้อมูล',
        positive: 'ช่องนี้รับเฉพาะจำนวนบวก',
      },
    },
  },
};

export default Winnonie;
